module.exports = __webpack_public_path__ + "img/shangyechuneng.47740f86.png";